<template>
	<div class="social overFlowXauto">
		<div class="social-left">
			<Tree @changeSwitch="changeSwitch" :switchVal="switchVal" @nodeClick="nodeClick"></Tree>
		</div>
		<div class="social-right">
			<TabelSearch :searchConfig="searchConfig" :searchParams="searchParams" @resetCallBack="resetCallBack" @search="setSearchParams"></TabelSearch>
			<Table :width="'100%'" :tableLoading="tableLoading" :tabelButtons="tabelButtons" :templateData="tableTemplateData"
			:tableConfig="tableConfig" :pagination="pagination">
			</Table>
		</div>
		<!-- 发布求助 -->
		<el-dialog :title="'发布求助'" :visible.sync="addDialogVisible" width="500px" :before-close="addHandleClose">
			<div class="money-box">
				<div class="label">
					是否有偿
				</div>
				<div class="money">
					<div class="radio">
						<el-radio v-model="addRuleForm.isReword" label="1">无偿</el-radio>
						<el-radio v-model="addRuleForm.isReword" label="2">有偿</el-radio>
					</div>
					<div class="money-input" v-if="addRuleForm.isReword==='2'">
						<el-input-number v-model="addRuleForm.reward" controls-position="right" :min="1" :max="10000"></el-input-number> <span slot="append"> 元/人</span>
					</div>
				</div>
			</div>
			<editForm ref="editForm" :formConfig="addFormConfig" :rules="addRules" :ruleForm="addRuleForm" :buttonConfig="addButtonConfig"></editForm>
		</el-dialog>
		<!-- 批量禁用 -->
		<el-dialog :title="'禁用说明'" :visible.sync="ignoreDialogVisible" width="500px" :before-close="ignoreHandleClose">
			<div class="input-label">
				<div class="label">审核备注</div>
				<div class="input">
					<el-input type="textarea" :disabled="isShowIgnore" :autosize="{ minRows: 4, maxRows: 8}" placeholder="请输入内容" v-model="ignoreTextarea"></el-input>
				</div>
			</div>
			<div class="ignore-btn">
				<el-button v-if="!isShowIgnore" type="danger" @click="ignoreConfirm">禁用</el-button>
				<el-button type="primary" @click="ignoreHandleClose">返回</el-button>
			</div>
		</el-dialog>
		<!-- 查看详情 -->
		<el-dialog :title="'查看详情'" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<div class="form-detail">
				<div class="user-info">
					<div class="user-img">
						<el-avatar shape="square" :size="100" :src="detailInfo.portrait"></el-avatar>
					</div>
					<div class="user-detail">
						<div class="item-box">
							<div class="item-title">姓名：</div>
							<div class="item-value">{{detailInfo.name}}</div>
						</div>
						<div class="item-box">
							<div class="item-title">手机号：</div>
							<div class="item-value">{{detailInfo.phone}}</div>
						</div>
						<div class="item-box">
							<div class="item-title">发布时间：</div>
							<div class="item-value">{{detailInfo.createGmt}}</div>
						</div>
					</div>
					<div class="user-detail">
						<div class="item-box">
							<div class="item-title">求助人数：</div>
							<div class="item-value">{{detailInfo.peopleNum}}</div>
						</div>
						<div class="item-box">
							<div class="item-title">酬金：</div>
							<div class="item-value">{{detailInfo.reward}}</div>
						</div>
						<div class="item-box">
							<div class="item-title">求助地址：</div>
							<div class="item-value">{{detailInfo.address}}</div>
						</div>
					</div>
					<!-- <div class="btn" v-if="!detailInfo.isIgnore&&!detailInfo.resolved">
						<el-button v-if="!detailInfo.alarm" type="danger" :disabled="alarmBtnDisabled" @click="alarm">发起报警</el-button>
						<el-button v-else type="primary">已报警</el-button>
					</div> -->
				</div>
				<info bgColor="rgb(242, 242, 242)" :file="detailInfo.fileRes" :content="detailInfo.content"/>
				<div class="info-list" v-for="(item,index) in detailInfo.clues" :key='index'>
					<div class="clues-title">
						<div>
								<span>{{item.level}}指挥中心</span>
								<span> {{item.name}} </span>
								<span style="color: #66b1ff;">【增加线索】</span>
								<span> {{item.createGmt}} </span>
								<span>{{item.address}}</span>
						</div>
						<div v-if="!detailInfo.isIgnore&&!detailInfo.resolved" class="info-del" style="color: red;cursor: pointer;" @click="delInfo(item.id)">删除</div>
					</div>
					<info :bgColor="'rgb(241, 246, 248)'" borderColor="rgb(228, 228, 228)" :file="item.files" :content="item.content"/>
				</div>
			</div>
			<div class="form-btn" v-if="!detailInfo.isIgnore">
				<el-button v-if="!detailInfo.resolved" type="primary" @click="addInfo">添加线索</el-button>
				<el-button type="success" v-if="detailInfo.owner&&!detailInfo.resolved" @click="resolveInfo">完成求助</el-button>
			</div>
		</el-dialog>
		<!-- 添加线索 -->
		
		<el-dialog :title="'添加线索'" width="50%" :visible.sync="infoDialogVisible" :before-close="infoHandleClose">
			<editForm :formConfig="infoFormConfig" :rules="infoRules" :ruleForm="infoRuleForm" :buttonConfig="infoButtonConfig"></editForm>
		</el-dialog>
	</div>
</template>

<script>
	import Tree from '../../../../components/Tree/nodeTree';
	import Info from './help-info.vue';
	import TabelSearch from '../../../../components/tabel-search/tabel-search';
	import {assitanceApi} from '../../../../api-path/assitance-api.js'
    import publicApi from "../../../../api-path/public-api";
	export default {
		components: {
			Tree,
			Info,
			TabelSearch
		},
		data() {
			return {
				squareUrl: '',
				switchVal: true,
				//批量禁用审核备注
				ignoreTextarea:'',
				ignoreList:[],
				ignoreDialogVisible:false,
				isShowIgnore:false,
				//求助详情
				detailInfo:{},
				//表格start
				searchConfig: {
					dataName: 'searchParams',
					items: [{
						key: 'reward',
						valueType: 'select',
						placeholder: '是否有偿',
						option: {
							label: 'name',
							value: 'id'
						},
						data: [{
							name: '无偿',
							value: false
						}, {
							name: '有偿',
							value: true
						}],
					}, {
						key: 'resolved',
						valueType: 'select',
						placeholder: '是否解决',
						option: {
							label: 'name',
							value: 'id'
						},
						data: [{
							name: '未解决',
							value: false
						}, {
							name: '已解决',
							value: true
						}],
					}, {
						key: 'isIgnore',
						valueType: 'select',
						placeholder: '是否禁用',
						option: {
							label: 'name',
							value: 'id'
						},
						data: [{
							name: '已启用',
							value: false
						}, {
							name: '已禁用',
							value: true
						}],
					}, {
						key: 'search',
						valueType: 'text',
						placeholder: '请输入关键词',
					}]
				},
				searchParams: {
					areaId: '',
					areaName: '',
					isDown:true,
					resolved: '',
					reward:'',
					search: '',
					isIgnore:'',
					page: 1,
					size: 15,
				},
				tableLoading: false,
				tabelButtons: [{
					type: 'add',
					title: '发布求助',
					fn: () => {
						this.addRuleForm={
							title: '',
					address: '',
					content: '',
					peopleNum: 1,
					isReword: '1',
					reward:1,
					longitude:'',
					latitude:'',
					files:[]
				}
						this.addDialogVisible = true;
					}
				}, {
					type: 'forbidden', //
					title: '批量禁用',
					fn: (data) => {
						data.map(item=>{
							this.ignoreList.push(item.id)
						})
						this.ignoreTextarea='';
						this.isShowIgnore=false;
						this.ignoreDialogVisible=true;
					}
				}],
				tableTemplateData: [],
				tableConfig: {
					checkbox: true,
					checkboxFn: () => {
						
					},
					rows: [{
						label: '区域',
						prop: 'areaName',
					}, {
						label: '标题',
						width:'150px',
						type:'popover',
						prop: 'title',
					}, {
						label: '内容',
						prop: 'content',
						type:"popover",
						width:'150px',
					}, {
						label: '地址',
						width:'180px',
						type:"popover",
						prop: "address"
					}, {
						label: '发布时间',
						width:'140px',
						prop: 'createGmt'
					}, {
						label: '求助人数',
						prop: 'peopleNum'
					}, {
						label: '酬金(元/人)',
						prop: 'reward'
					},{
						label:'是否解决',
						prop:'resolved',
						type:'status',
						activeText:'已解决',
						text:"未解决",
					},{
						label: '是否禁用',
						type: 'status',
						prop: 'isIgnore',
						activeColor:'',
						activeText:'已禁用',
						text:"已启用",
						showWord:false,
						fn:(data)=>{
							if(data.isIgnore){
								this.ignoreDialogVisible=true;
								this.isShowIgnore=true;
								this.ignoreTextarea=data.ignoreRemark?data.ignoreRemark:'暂无审核信息';
							}else{
								this.ignoreDialogVisible=true;
								this.isShowIgnore=false;
								this.ignoreTextarea='';
								this.ignoreList=[data.id];
							}
						}
					}],
					rowButtons: {
						// width: '100px',
						items: [{
							label: '查看',
							fn: (data) => {
								this.getDetailInfo(data);
							}
						}],
					},
				},
				pagination: {
					show: true,
					total: 0,
					page: 1,
					size: 15,
					sizeChange: this.sizeChange,
					pageChange: this.pageChange,
				},
				//表格end
				dialogVisible: false,
				//表单配置start
				addDialogVisible: false,
				addRuleForm: {
					title: '',
					address: '',
					content: '',
					peopleNum: 1,
					isReword: '1',
					reward:1,
					longitude:'',
					latitude:'',
					files:[]
				},
				addRules: {
					title: [{
						required: true,
						trigger: 'change',
						message: '请填写标题',
					}],
					peopleNum: [{
						required: true,
						trigger: 'change',
						message: '请填写人数',
					}],
					address: [{
						required: true,
						trigger: 'change',
						message: '请填写地址',
					}],
				},
				addFormConfig: {
					ref:'editMap',
					disabled: false,
					items: [
						[{
							valueType: 'input', // 类型
							label: '标题',
							key: 'title', // 数据名称
							prop: 'title', // 验证规则
							labelWidth: "100px", // label 宽度
							maxlength: '50',
							itemWidth: '100%',
							placeholder: '请输入标题', // 提示信息
						}],
						[{
							valueType: 'inputNumber', // 类型
							label: '求助人数',
							key: 'peopleNum', // 数据名称
							prop: 'peopleNum', // 验证规则
							labelWidth: "100px", // label 宽度
							max: 100,
							min: 1,
							itemWidth: '100%',
							placeholder: '请选择人数', // 提示信息
						}],
						[{
							valueType: 'nautica2', // 类型
							label: '求助地址',
							key: 'address', // 数据名称
							prop: 'address', // 验证规则
							labelWidth: "100px", // label 宽度
							maxlength: '50',
							itemWidth: '100%',
							disabled:true,
							placeholder: '请输入地址', // 提示信息
						}],
						[{
							valueType: 'textarea', // 类型
							label: '详细内容',
							key: 'content', // 数据名称
							prop: 'content', // 验证规则
							labelWidth: "100px", // label 宽度
							maxlength: '500',
							itemWidth: '67%',
							placeholder: '求助内容', // 提示信息
						}],
						[{
                            // valueType: 'singleUpload', // 类型
							valueType: 'upload', // 类型
							label: '上传图片',
							key: 'files', // 数据名称
							prop: 'files',
							labelWidth: "100px", // label 宽度
							itemWidth: '100%',
							disabled: false,
							otherConfig: {
								showInfoInput: false,
								// infoInputPlaceholder: '请输入图片文字说明',
                                imgWidth: '100px',
                                imgHeight: '80px',
								uploadHint: '注：支持jpg、png、tif、gif等格式且不超过20M，最多传9张',
								method: ['delete', 'edit']
							},
							uploadConfig: {
								accept: 'image/jpg,image/jpeg, image/png, image/tif, image/gif',
								uploadPath: publicApi.uploadFile,
								size: '20480kb',
								count: 9
							},
							options: {
								fileUrlKey: 'url',
								fileInfoKey: 'description',
							},
						}, ],
					]
				},
				addButtonConfig: {
					buttons: [{
							type: 'save', // 发布
							loading: false,
							fn: (data) => {
								console.log(data);
								data.isReword=='1'?(data.isReword=false,data.reward=0):(data.isReword=true);
								this.$http.post(assitanceApi.save, data).then(res => {
									if (res.status === 200) {
										this.$message({
											type: 'success',
											message: '操作成功!',
										});
										this.addDialogVisible = false;
										this.setSearchParams()
									}
								})
							},
						}, {
							type: 'back', // 重置
							fn: () => {
								this.addDialogVisible = false;
							},
						},

					]
				},
				//表单配置end
				
				//添加线索表单配置start
				alarmBtnDisabled:false,//发起报警按钮
				infoDialogVisible: false,
				infoRuleForm: {
					belongId:"",
					content: '',
					files:[]
				},
				infoRules: {
					content: [{
						required: true,
						trigger: 'change',
						message: '请填写内容',
					}],
				},
				infoFormConfig: {
					disabled: false,
					items: [
						[{
							valueType: 'textarea', // 类型
							label: '详细内容',
							key: 'content', // 数据名称
							prop: 'content', // 验证规则
							labelWidth: "100px", // label 宽度
							maxlength: '500',
							itemWidth: '67%',
							placeholder: '求助内容', // 提示信息
						}],
						[{
							valueType: 'upload', // 类型
							label: '上传图片',
							key: 'files', // 数据名称
							labelWidth: "100px", // label 宽度
							prop: 'files',
							itemWidth: '100%',
							disabled: false,
							otherConfig: {
								showInfoInput: false,
								infoInputPlaceholder: '请输入图片文字说明',
								imgWidth: '100px',
								uploadHint: '注：支持jpg、png、tif、gif等格式且不超过20M，最多传9张',
								imgHeight: '100px',
								method: ['delete', 'edit']
							},
							uploadConfig: {
								accept: 'image/jpg,image/jpeg, image/png, image/tif, image/gif',
								uploadPath: publicApi.uploadFile,
								size: '20480kb',
								count: 9
							},
							options: {
								fileUrlKey: 'url',
								fileInfoKey: 'description',
							},
						}, ],
					]
				},
				infoButtonConfig: {
					buttons: [{
							type: 'save', // 发布
							loading: false,
							fn: (data) => {
								this.$http.post(assitanceApi.saveClue, data).then(res => {
									if (res.status === 200) {
										this.$message({
											type: 'success',
											message: '操作成功!',
										});
										this.$http.get(assitanceApi.findById,{params:{
											id:this.detailInfo.id
										}}).then(res=>{
											if(res.status===200){
												this.detailInfo=res.result;
											}
										})
										this.infoDialogVisible = false;
									}
								})
							},
						}, {
							type: 'back', // 重置
							fn: () => {
								this.infoRuleForm={
									belongId:"",
									content: '',
									files:[],
								};
								this.infoDialogVisible = false;
							},
						},
				
					]
				}
				//表单配置end
			}
		},
		mounted() {
		},
		methods: {
			changeSwitch(e) {
				this.switchVal = e;
				this.searchParams.isDown=e;
				this.setSearchParams();
			},
			nodeClick(node){
				this.areaId=node.id;
				this.searchParams.areaId=node.id;
				this.searchParams.areaName=node.name;
				this.setSearchParams()
			},
			resetCallBack() {
				this.searchParams.resolved = '';
				this.searchParams.reward = '';
				this.searchParams.search = '';
				this.searchParams.isIgnore = '';
				this.searchParams.page = this.pagination.page=1;
				this.searchParams.size = this.pagination.size=15;
				this.searchParams.isIgnore = '';
				this.searchParams.areaId = this.areaId;
				this.setSearchParams();
			},
			// 每页显示条数
			sizeChange(size) {
				this.pagination.size = size;
				this.searchParams.size = size;
				this.setSearchParams()
			},
			// 当前页
			pageChange(page) {
				this.pagination.page = page
				this.searchParams.page = page;
				this.setSearchParams()
			},
			setSearchParams(value) {
				if(value){
					this.pagination.page=value.page;
				}
				this.$http.get(assitanceApi.queryListByPage,{params:this.searchParams}).then(res=>{
					console.log(res);
					if(res.status===200){
						this.tableTemplateData=res.result.pageList;
						this.pagination.total=res.result.total
					}
				})
			},
			//批量禁用start
			ignoreHandleClose(){
				this.ignoreDialogVisible=false;
			},
			ignoreConfirm(){
				let params={
					ids:this.ignoreList,
					ignore:true,
					ignoreRemark:this.ignoreTextarea,
				}
				if(this.ignoreTextarea!=''){
					this.$http.post(assitanceApi.setIgnore,params).then(res=>{
						if(res.status==200){
							this.$message({
								type:'success',
								message:'操作成功！'
							})
							this.ignoreDialogVisible=false;
							this.setSearchParams()
						}else{
							this.$message({
								type:'error',
								message:res.msg
							})
						}
					})
				}else{
					this.$message({
						type:'warning',
						message:'请输入审核信息！'
					})
				}
			},
			//批量禁用end
			
			//查看详情----start----
			getDetailInfo(data){
				let params={
					id:data.id
				}
				this.$http.get(assitanceApi.findById,{params}).then(res=>{
					if(res.status===200){
						this.detailInfo=res.result;
						this.dialogVisible = true;
					}
				})
			},
			handleClose() {
				this.dialogVisible = false;
				this.alarmBtnDisabled=false;
			},
			//关闭详情
			closeDialog() {
				this.dialogVisible = false;
			},
			//完成求助
			resolveInfo(){
				this.$http.get(assitanceApi.setResolved,{params:{id:this.detailInfo.id}}).then(res=>{
					if(res.status==200){
						this.$message({type:'success',message:'操作成功！'});
						this.dialogVisible=false;
						this.setSearchParams()
					}
				})
			},
			//添加线索
			addInfo(){
				this.infoRuleForm.belongId=this.detailInfo.id;
				this.infoRuleForm.content='';
				this.infoRuleForm.files=[];
				this.infoDialogVisible=true;
			},
			infoHandleClose(){
				this.infoDialogVisible=false;
			},
			//发起报警
			alarm(){
				this.$http.get(assitanceApi.sendAlarm,{params:{id:this.detailInfo.id}}).then(res=>{
					this.alarmBtnDisabled=true;
					if(res.status==200){
						this.$message({
							type:'success',
							message:'已成功发起报警！'
						})
					}else{
						this.alarmBtnDisabled=false;
					}
				})
			},
			//删除线索
			delInfo(id){
						this.$confirm('确认删除该线索?', '删除线索', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
							}).then(() => {
								this.$http.get(assitanceApi.delClue,{params:{id:id}}).then(res=>{
									if(res.status===200){
											this.$message({
												type: 'success',
												message: '操作成功',
											});
											
											this.$http.get(assitanceApi.findById,{params:{
												id:this.detailInfo.id
											}}).then(res=>{
												if(res.status===200){
													this.detailInfo=res.result;
												}
											})
									}
								})
							}).catch(() => {
								this.$message({
									type: 'info',
									message: '已取消操作',
								});
							});
			},
			//查看详情----end-----
			
			//新增发布----------start
			addHandleClose() {
				this.addDialogVisible = false;
			}
			//新增----------end
		}
	}
</script>

<style lang="less" scoped>
	.social {
		margin-left: 10px;
		box-sizing: border-box;
		height: 100%;
		padding: 10px;
		border-radius: 10px;
		background: #fff;
		display: flex;

		.social-left {
			margin-right: 10px;
			border-right: 1px solid #c1c1c1;
		}

		.social-right {
			flex: 1;
			display: flex;
			flex-direction: column;
		}

		//查看
		.form-detail {
			height: 50vh;
			overflow-y: scroll;
			.info-list{
				.clues-title{
					display: flex;
					justify-content: space-between;
					padding: 0 10px;
				}
			}
			.user-info {
				display: flex;
				// background: #e7f6fb;
				padding: 10px;
				border-radius: 5px;

				.user-detail {
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					height: 80px;
					margin-left: 20px;
					flex: 1;
				}
			}

			.item-box {
				display: flex;
				margin-top: 20px;
				position: relative;
				align-items: center;

				.status {
					position: absolute;
					right: 0;
					color: red;
				}
			}
		}

		.form-btn {
			margin-top: 30px;
			display: flex;
			justify-content: center;
		}
		.input-label{
			.input{
				margin: 30px 0;
				.el-textarea{
					width: 100%;
				}
			}
		}
		.ignore-btn{
			display: flex;
			justify-content: center;
		}
		//是否有偿
		.money-box{
			display: flex;
			margin-bottom: 30px;
			.label{
				width: 100px;
				text-align: right;
				padding: 0 12px 0 0;
				box-sizing: border-box;
				&::before{
					content: '*';
					color: #F56C6C;
					margin-right: 4px;
				}
			}
			.money{
				display: flex;
				flex-direction: column;
				.el-input-number{
					width: auto;
				}
				.money-input{
					margin: 10px 0 0 0;
				}
			}
		}
	}
</style>
